"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormQuestion = void 0;
const uuid = __importStar(require("uuid"));
const FormQuestionControllerRegistry_1 = __importDefault(require("../FormQuestionController/FormQuestionControllerRegistry"));
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
function createFormQuestion(o = {}, forceNewId = false) {
    const config = Object.values(FormQuestionType_1.default).reduce((p, c) => {
        var _a;
        return (Object.assign(Object.assign({}, p), { [c]: FormQuestionControllerRegistry_1.default[c].createConfig((_a = o === null || o === void 0 ? void 0 : o.config) === null || _a === void 0 ? void 0 : _a[c]) }));
    }, {});
    const result = Object.assign(Object.assign({ qId: uuid.v4(), title: '', type: FormQuestionType_1.default.CHECK }, (o || {})), { answer: [...((o === null || o === void 0 ? void 0 : o.answer) || [])], enabled: (o === null || o === void 0 ? void 0 : o.enabled) || true, config });
    if (forceNewId)
        result.qId = uuid.v4();
    return result;
}
exports.createFormQuestion = createFormQuestion;
exports.default = createFormQuestion;
